export default {
  title: 'Dit restaurant kan nog niet live gaan',
  description:
    'Je partneraccount heeft geen verwerkingskosten voor online betalingen en heeft geen marge van 0% bevestigd. Stripe brengt zijn kosten in rekening bij je platform, dus een van beide moet eerst worden bepaald.',
  partner_action:
    'Stel standaard verwerkingskosten in, of bevestig dat je je restaurants geen kosten in rekening brengt en de kosten van Stripe zelf betaalt.',
  ask_partner:
    'Je partner heeft de verwerkingskosten voor onlinebetalingen nog niet ingesteld. Dit restaurant kan live gaan zodra dat is gebeurd.',
  buttons: {
    set_rate: 'Verwerkingskosten instellen',
    close: 'Sluiten',
  },
};
